// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"4e925abb","452":"b0133cfd","576":"dd71d3cd","604":"b0133cfd","674":"9c372b67","745":"da570797"}[chunkId] + ".chunk.css";
};